import { useLanguageContext } from "../../../../context/LanguageContext";
import AxisConfigPage from "../../../../pages/integrations/axis_configs/axis_config/AxisConfigPage";
import { useAxisConfigCreateRouteValidator } from "../../../validators/integrations/axis/AxisConfigCreateRouteValidator";
import { RouteConfig } from "../../RouteConfig";
import useAxisConfigsRouteConfig from "./AxisConfigsRouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useAxisConfigCreateRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/integrations/axis/create")
    .setLabel(
      translate("eva.main.entities.states.create", [
        {
          key: "entities",
          value: translate("eva.main.entities.axis_config"),
        },
      ])
    )
    .setValidator(useAxisConfigCreateRouteValidator())
    .setPage(<AxisConfigPage />)
    .setParent(useAxisConfigsRouteConfig());
}

export default useAxisConfigCreateRouteConfig;